import type { FeeSchedule } from "@netkeep/fee-types";
import { VERIFICATION_LABEL, VERIFICATION_TONE, shortDate } from "@/lib/format";
import { Badge, ExternalLink } from "./ui";

/**
 * One quiet line telling the user how trustworthy the selected fee data is:
 * verification badge, a short status, and a link to the official source.
 * Where the data came from (server, cache, bundled) is shown in Settings.
 */
export function FeeDataNotice({ schedule }: { schedule: FeeSchedule | null }) {
  if (!schedule) {
    return <p className="notice">You enter every fee yourself.</p>;
  }
  return (
    <div className="notice">
      <Badge label={VERIFICATION_LABEL[schedule.verificationStatus]} tone={VERIFICATION_TONE[schedule.verificationStatus]} />
      <span className="grow ellipsis">
        {schedule.lastVerifiedAt ? `Checked ${shortDate(schedule.lastVerifiedAt)}` : "Confirm rates with the platform"}
      </span>
      {schedule.source ? (
        <ExternalLink href={schedule.source.url} label={`Fee source: ${schedule.source.title} (opens in a new tab)`}>
          Source
        </ExternalLink>
      ) : null}
    </div>
  );
}
